// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
    padding: 20px;
    font-family: 'Arial', sans-serif;
    max-width: 800px;
    margin: 0 auto;
}

.title {
    text-align: center;
    font-size: 2rem;
    color: #333;
}

.form {
    margin-bottom: 20px;
    padding: 15px;
    border: 1px solid #ccc;
    border-radius: 8px;
    background-color: #f9f9f9;
}

.form-group {
    margin-bottom: 15px;
}

.label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
    color: #555;
}

.input,
.textarea,
.select {
    width: 100%;
    padding: 10px;
    font-size: 1rem;
    border-radius: 5px;
    border: 1px solid #ccc;
    background-color: #fff;
}

.textarea {
    height: 100px;
    resize: none;
}

.button {
    padding: 10px 15px;
    font-size: 1rem;
    border: none;
    border-radius: 5px;
    background-color: #007bff;
    color: white;
    cursor: pointer;
    transition: background-color 0.3s;
    margin-right: 10px;
}

.button:hover {
    background-color: #0056b3;
}

.button:disabled {
    background-color: #a8d3ff;
    cursor: not-allowed;
}

.message {
    color: #007bff;
    font-weight: bold;
    margin-top: 10px;
}

.test-result {
    font-weight: bold;
    margin-top: 10px;
    color: #555;
}

.server-list {
    margin-top: 20px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    background-color: #f9f9f9;
}

.server-item {
    margin-bottom: 10px;
    font-size: 1rem;
    color: #333;
}

.server-item strong {
    color: #007bff;
}

`, "",{"version":3,"sources":["webpack://./src/pages/AddServer.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gCAAgC;IAChC,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;AACf;;AAEA;;;IAGI,WAAW;IACX,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".container {\n    padding: 20px;\n    font-family: 'Arial', sans-serif;\n    max-width: 800px;\n    margin: 0 auto;\n}\n\n.title {\n    text-align: center;\n    font-size: 2rem;\n    color: #333;\n}\n\n.form {\n    margin-bottom: 20px;\n    padding: 15px;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    background-color: #f9f9f9;\n}\n\n.form-group {\n    margin-bottom: 15px;\n}\n\n.label {\n    display: block;\n    margin-bottom: 5px;\n    font-weight: bold;\n    color: #555;\n}\n\n.input,\n.textarea,\n.select {\n    width: 100%;\n    padding: 10px;\n    font-size: 1rem;\n    border-radius: 5px;\n    border: 1px solid #ccc;\n    background-color: #fff;\n}\n\n.textarea {\n    height: 100px;\n    resize: none;\n}\n\n.button {\n    padding: 10px 15px;\n    font-size: 1rem;\n    border: none;\n    border-radius: 5px;\n    background-color: #007bff;\n    color: white;\n    cursor: pointer;\n    transition: background-color 0.3s;\n    margin-right: 10px;\n}\n\n.button:hover {\n    background-color: #0056b3;\n}\n\n.button:disabled {\n    background-color: #a8d3ff;\n    cursor: not-allowed;\n}\n\n.message {\n    color: #007bff;\n    font-weight: bold;\n    margin-top: 10px;\n}\n\n.test-result {\n    font-weight: bold;\n    margin-top: 10px;\n    color: #555;\n}\n\n.server-list {\n    margin-top: 20px;\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    background-color: #f9f9f9;\n}\n\n.server-item {\n    margin-bottom: 10px;\n    font-size: 1rem;\n    color: #333;\n}\n\n.server-item strong {\n    color: #007bff;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
